import { useQuery } from '@tanstack/react-query';
import { IAccountMeetingsResponse } from '../../../viewmodels/CalendarViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useAdminZoomMeetingsByAccountQuery(accountId: string, options?: { enabled?: boolean }) {
	const userSession = useUserSession();

	return useQuery({
		queryKey: ['admin', 'zoom', 'meetings', 'byAccount', accountId],
		queryFn: async () => {
			const url = `admin/zoom/meetings/byAccount/${encodeURIComponent(accountId)}`;
			return userSession.webServiceHelper.callAsync<IAccountMeetingsResponse>(url, 'GET');
		},
		enabled: options?.enabled ?? true,
		staleTime: 5 * 60 * 1000, // 5 minutes - admin data doesn't change frequently
	});
}
